<template>
	<el-header class="pageHeader">
		<img :src="ImgUrlFix + '/images/logo.png'" @click="toIndex" alt="" />
		<div class="pageHeader_text">
			<span>{{ lang.public.title }}</span>
			<slot name="title"></slot>
		</div>
		<div style="margin-left: auto">
			<el-popover placement="top-start" trigger="hover" content="this is content, this is content, this is content">
				<template #reference>
					<div class="logoutBox">
						<img :src="headUrl">
						<span>{{ userInfo.realName }}</span>
					</div>
				</template>
				<ul class="pageHeader_list">
					<li>
						<span class="pointer" @click="logout">退出登录</span>
					</li>
					<li>
						<span	span class="pointer" @click="showPersonModal">个人信息</span>
					</li>
				</ul>
			</el-popover>
		</div>
	</el-header>
	<el-dialog v-model="isShowPersonModal" title="个人信息">
		<el-form label-width="80" :model="store.state.userInfo">
			<el-form-item label="姓名" prop="realName"><el-input v-model="store.state.userInfo.realName" disabled></el-input></el-form-item>
			<el-form-item label="出生日期" prop="birthday"><el-input v-model="store.state.userInfo.birthday" disabled></el-input></el-form-item>
			<el-form-item label="机构名字" prop="organizationName"><el-input v-model="store.state.userInfo.organizationName" disabled></el-input></el-form-item>
			<el-form-item label="部门" prop="departmentName"><el-input v-model="store.state.userInfo.departmentName" disabled></el-input></el-form-item>
		</el-form>
	</el-dialog>
</template>

<script setup lang="ts">
import { defineProps, reactive, computed, ref, watch, Ref, defineExpose, toRefs } from 'vue';
import { useStore } from 'vuex';
import { ImgUrlFix } from '@u/config'
import router, { newRouter } from "@/router";
import { RouteRecordRaw } from "vue-router";
import { geturlbysize } from '@/request/api/fileServer/images';



const props = withDefaults(defineProps<{
	formData: any
}>(), {
	formData: () => ({})
});
// const emit = defineEmits<{

// }>()

const store = useStore();
const lang = store.state.config.lang
const userInfo = computed(() => store.state.userInfo || {})

const state = reactive({
	realName: lang.components.top.userStr,   //用户名
	isShowPersonModal: false,
	headUrl: ''
})
const toIndex = () => {
	router.replace({
		name: 'layout'
	})
}

const getHead = async () => {
	state.headUrl = await geturlbysize({
		data: {
			type: 8,
			objectId: store.state.userInfo.headPhoto
		},
		header: {
			appid: 'br.com'
		}
	})
}

watch(() => store.state.userInfo, () => {
	if (store.state.userInfo) {
		state.realName = store.state.userInfo.realName
		getHead()
	} else {
		state.realName = lang.components.top.userStr
	}
	
}, { immediate: true })

const logout = () => {
	store.commit('setOrganization', '')
	store.commit('setAccessToken', '');
	store.commit('setUserInfo', null);
	store.commit('setRouteList', [])
	store.commit('setMenuList', [])
	localStorage.removeItem('AccessToken')
	const newRouterArr = newRouter.getRoutes().map(item => item.name)
	router.getRoutes().forEach(item => {
		if (newRouterArr.indexOf(item.name) == -1) {
			//@ts-ignore
			router.removeRoute(item.name)
		}
	})
	store.commit('setIsGetInfo', false)
	router.push({ name: 'login' })
}
const showPersonModal = async () => {
	state.isShowPersonModal = true;
}

const {
	realName,
	isShowPersonModal,
	headUrl
} = toRefs(state)
</script>

<style lang="scss" scoped>
@import '../../../static/style/variable.scss';

.pageHeader {
	width: 100%;
	height: 0.8rem;
	display: flex;
	align-items: center;
	background-color: $basic-black-2;
	color: $white-text;
	font-size: 0.3rem;
	line-height: 0.3rem;
	&_text {
		display: flex;
		align-items: center;
	}
	img {
		height: 0.5rem;
		margin-right: 0.3rem;
	}
}

.logoutBox {
	display: flex;
	align-items: center;
	font-size: 0.2rem;
	line-height: 0.3rem;

	img {
		height: 0.5rem;
		margin-right: 0.1rem;
	}
}
</style>
<style lang="scss">
@import '../../../static/style/variable.scss';

	.pageHeader_list {
		padding: 0;
		margin: 0;
		li {
			padding: 10px 0;
			&:hover {
				color: $majorColor-1;
			}
			
		}
	}
</style>